import 'angular-translate';
import './app';
import './appResolveService';
import './bootstrapService';
import './languageLoader';
import './interceptors/sevenInterceptor';
import './interceptors/httpInterceptor';

export default '7Terminal.Bootstrap';
